module.exports = __webpack_public_path__ + "HeartSearch-2levzGC.svg";